import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AiFillLeftCircle, AiFillRightCircle } from 'react-icons/ai';
import { Col } from 'antd';

import Menu from '~/pages/_partials/Menu';
import Header from '~/pages/_partials/Header';
import Footer from '~/pages/_partials/Footer';
import Top from '~/pages/_partials/Top';
import EnviromentHeader from '~/pages/_partials/EnviromentHeader';
import { decrypt } from '~/Utils';

import { Container, DrawerButton, CustomDrawer, DrawerContent } from './styles';

export default function FullLayout({ children }) {
  const [open, setOpen] = useState(false);
  const enviroment = process.env.REACT_APP_ENVIROMENT;
  const { email = '' } = JSON.parse(decrypt(localStorage.getItem('@App:user') || '') || '{}');
  const isAdmin = email === 'admin@w2z.com.br';

  return (
    <>
      <Container className="layout">
        {enviroment !== 'production' && <EnviromentHeader />}
        <Top />
        <Header>
          <Menu />
        </Header>
        <main>{children}</main>
        <Footer />
      </Container>

      {isAdmin && (
        <>
          <DrawerButton onClick={() => setOpen(!open)} $open={open}>
            <Col style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {open ? <AiFillRightCircle size={30} /> : <AiFillLeftCircle size={30} />}
            </Col>
          </DrawerButton>
          <CustomDrawer className={open ? 'open' : ''}>
            <DrawerContent>
              <h3>Área do Admin</h3>
              <p>Conteúdo administrativo vai aqui...</p>
            </DrawerContent>
          </CustomDrawer>
        </>
      )}
    </>
  );
}

FullLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.any]).isRequired,
};
